import React from 'react';
import icons from 'src/icons';
import { PasswordInstruction } from 'src/shared/components/password-instruction/password-instruction';

import { Gap } from '@alfalab/core-components/gap';
import { SuperEllipse } from '@alfalab/core-components/icon-view/super-ellipse';
import { PureCell } from '@alfalab/core-components/pure-cell';
import { Space } from '@alfalab/core-components/space/cssm';

import { CollapseBlock } from '../collapse-block';

export const InstructionBody = () => (
    <React.Fragment>
        <Gap size='xl' />
        <Space direction='vertical' size={42} fullWidth={true}>
            <CollapseBlock title='Если помните пароль' isOpen={true}>
                <PureCell direction='horizontal' verticalPadding='default'>
                    <PureCell.Graphics>
                        <SuperEllipse size={48}>
                            <img src={icons.SpaceIcon} alt='icon' width={24} height={24} />
                        </SuperEllipse>
                    </PureCell.Graphics>
                    <PureCell.Content>
                        <PureCell.Main>
                            <PureCell.Text
                                titleColor='primary'
                                valueColor='secondary'
                                view='component'
                            >
                                Свяжитесь с Help Desk
                            </PureCell.Text>
                            <PureCell.Text
                                titleColor='secondary'
                                valueColor='secondary'
                                view='primary-small'
                            >
                                Скажите, что у&nbsp;вас заблокировалась учётная запись&nbsp;&mdash;
                                её&nbsp;разблокируют
                            </PureCell.Text>
                        </PureCell.Main>
                    </PureCell.Content>
                </PureCell>

                <PureCell direction='horizontal' verticalPadding='default'>
                    <PureCell.Graphics>
                        <SuperEllipse size={48}>
                            <img src={icons.VirginIcon} alt='icon' width={24} height={24} />
                        </SuperEllipse>
                    </PureCell.Graphics>
                    <PureCell.Content>
                        <PureCell.Main>
                            <PureCell.Text
                                titleColor='primary'
                                valueColor='secondary'
                                view='component'
                            >
                                Вернитесь сюда
                            </PureCell.Text>
                            <PureCell.Text
                                titleColor='secondary'
                                valueColor='secondary'
                                view='primary-small'
                            >
                                Войдите со старым паролем
                            </PureCell.Text>
                        </PureCell.Main>
                    </PureCell.Content>
                </PureCell>
            </CollapseBlock>

            <Space direction='vertical' size={26} fullWidth={true}>
                <CollapseBlock title='Если забыли пароль'>
                    <PasswordInstruction />
                </CollapseBlock>
            </Space>
        </Space>
    </React.Fragment>
);
